var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStateErrorIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.541,
    height: 17.538,
    viewBox: "0 0 17.541 17.538",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Error_Icon",
    "data-name": "Error Icon",
    transform: "translate(0.771 0.768)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_",
    "data-name": "!",
    transform: "translate(0 0.367)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape_Copy_4",
    "data-name": "Shape Copy 4",
    d: "M7.453.006C7.2.028,6.88.066,6.679.1A8.016,8.016,0,0,0,.419,5.406,8.461,8.461,0,0,0,.03,7.149a12,12,0,0,0,0,1.7A8.033,8.033,0,0,0,7.148,15.97a12,12,0,0,0,1.7,0A8.033,8.033,0,0,0,15.97,8.853a12,12,0,0,0,0-1.7A8.032,8.032,0,0,0,8.86.034C8.66.01,7.642-.01,7.453.006Z",
    transform: "translate(0 -0.367)",
    fill: "none",
    stroke: "#e63232",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("path", {
    id: "Final_payment_amount",
    "data-name": "Final payment amount",
    d: "M1.668-7.128a.954.954,0,0,0,1-.948.954.954,0,0,0-1-.948.951.951,0,0,0-.984.948A.951.951,0,0,0,1.668-7.128ZM.816,0H2.544V-6.276H.816Z",
    transform: "translate(6 12)",
    fill: "#e63232"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStateErrorIcon);
export default __webpack_public_path__ + "static/media/state-error-icon.fb1b5e18.svg";
export { ForwardRef as ReactComponent };